import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { ImportRequestModal } from './ImportRequestModal';
export const importRequestModalConfig = (biName, props)=>({
        biName,
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(ImportRequestModal, _object_spread_props(_object_spread({}, props), {
                dismissModal: dismissModal
            }));
        }
    });
